<template>
	<div :class="['square-button', widthClass]">
		<b-button :disabled="disabled" @click.stop="$emit('clicked')" class="w-100">
			<img :src="icon" :alt="iconAlt" class="mr-2" />
			{{ text }}
		</b-button>

	</div>
</template>

<script>
export default {
	name: "IconButton",

	props: {
		text: {
			type: String,
			default: "",
		},
		type: {
			type: String,
			default: "",
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		iconSrc: {
			type: String,
			default: "",
		},
		iconAlt: {
			type: String,
			default: "",
		},
		widthClass: {
			type: String,
			default: "button-fit-content",
		},
	},
	computed: {
		icon() {
			return require(`@/assets/${this.iconSrc}`);
		},
	},
};
</script>

<style>
.square-button .btn-secondary {
	background-color: var(--color-white);
	border: 1px solid var(--primary-blue);
	color: var(--primary-blue);
	padding: 0.25rem 0.625rem;
	font-family: "Montserrat", sans-serif;
	font-size: var(--size-13);
	font-weight: var(--weight-600);
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.3125rem;
	border-radius: 0.5rem;
}

.square-button .btn-secondary:hover {
	box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
		2px 3px 7px 0px rgba(32, 99, 155, 0.2),
		7px 10px 12px 0px rgba(32, 99, 155, 0.17),
		44px 63px 22px 0px rgba(32, 99, 155, 0);
}

.square-button .btn-secondary:focus {
	border: 1px solid var(--primary-blue);
	color: var(--primary-blue);
	box-shadow: none;
}
.square-button .btn-secondary:focus:hover {
	border: 1px solid var(--primary-blue);
	color: var(--primary-blue);
	box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
		2px 3px 7px 0px rgba(32, 99, 155, 0.2),
		7px 10px 12px 0px rgba(32, 99, 155, 0.17),
		44px 63px 22px 0px rgba(32, 99, 155, 0);
}

.square-button .btn-secondary:disabled {
	box-shadow: none;
	opacity: 0.65 !important;
}

.square-button .btn-secondary:not(:disabled):not(.disabled):active,
.square-button .btn-secondary:not(:disabled):not(.disabled).active,
.square-button .show > .btn-secondary.dropdown-toggle {
	color: var(--primary-blue);
	background-color: var(--color-white);
	border-color: var(--primary-blue);
	box-shadow: none;
}

.icon-button-width {
	width: 35%;
}

.button-fit-content {
	width: fit-content;
}
.btn-update .btn-secondary {
	display: flex;
	flex-direction: column;
	height: 92px;
}
.btn-update .btn-secondary img {
width: 32px !important;
height: 32px !important;
}
</style>
